import { useTranslation } from "react-i18next";
import FormInput from "components/blocks/FormInput";
import { useState, useMemo } from "react";
import PublicationBookCard from "./PublicationBookCard";
import { useQuery } from "hooks/useQuery";
import { LookupService } from "services/lookupService";
import { ScientificPublicationsService } from "services/scientificPublicationsService";
import { DataGridRequest } from "services/shared-models/sharedTypes";
import { OperatorFilter } from "services/shared-models/sharedEnums";
import {useCookieContext} from "../../../../contexts";
import Select from "react-select";

const PublicationsGallery = () => {
  const { t, i18n } = useTranslation("WelcomePage");
    const { isAr } = useCookieContext();
  const [search, setSearch] = useState("");
  const [triggerSearchOnClick, setTriggerSearchOnClick] = useState(false);
  const [selectedPublicationType, setSelectedPublicationType] = useState(-1);

  const { data, loading } = useQuery({
    queryFn: async () => {
      return await LookupService.getAllTypeOfScientificDropDown();
    },
      triggers: [isAr]
  } );

  const { data: allPublicScientificPublishing, loading: allPublicScientificPublishingLoading } = useQuery({
    queryFn: async () => {
      const filter: DataGridRequest["filter"] =
        selectedPublicationType === -1
          ? []
          : [
              {
                field: "TypeOfScientificId",
                value: selectedPublicationType,
                operator: OperatorFilter.equal,
              },
            ];

      return await ScientificPublicationsService.getAllPublicScientificPublishing({
        search: search ? search : undefined,
        pageIndex: 0,
        pageSize: 1000,
        filter: filter,
      });
    },
    triggers: [selectedPublicationType, triggerSearchOnClick,isAr],
  });

  const publicationTypeOptions = useMemo(() => {
    const allOption = {
      value: -1,
      label: i18n.language.toLowerCase() === "ar" ? "الكل" : "all",
    };
    const options = (data ?? []).map((type) => ({
      value: type.id,
      label: type.details.find((x) => x.locale.toLowerCase() === i18n.language.toLowerCase())?.displayName ?? "",
    }));
    return [allOption, ...options];
  }, [data, i18n.language]);

  return (
    <div>
      {/* Search box & Type Filter */}
      <div className="d-flex flex-column flex-sm-row gap-3 my-4 align-items-sm-end w-100">
        <FormInput
          placeholder={t("Common:search")}
          wrapperClassName="flex-1 w-100"
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="w-100" style={{ minWidth: 200 }}>
          <Select
            isLoading={loading}
            options={publicationTypeOptions}
            value={publicationTypeOptions.find((o) => o.value === selectedPublicationType)}
            onChange={(option) => setSelectedPublicationType(option?.value ?? -1)}
            isSearchable={false}
            placeholder={i18n.language.toLowerCase() === "ar" ? "الكل" : "all"}
          />
        </div>
        <button className="btn btn-primary px-4 w-100" onClick={() => setTriggerSearchOnClick(!triggerSearchOnClick)}>
          {t("Common:search")}
        </button>
      </div>

      {/* Publications List */}
      <div className="d-flex gap-4 flex-wrap justify-content-center justify-content-md-start">
        {allPublicScientificPublishingLoading ? (
          <div className="custom-loader"></div>
        ) : (
          allPublicScientificPublishing?.map((ele, index) => (
            <PublicationBookCard key={index} scientificPublishing={ele} />
          ))
        )}
      </div>
    </div>
  );
};

export default PublicationsGallery;
